import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3fio9sxbn1: FaireBrandEntity = {
  token: "b_3fio9sxbn1",
  type: "brand",
  name: "Third Drawer Down USA",
  avatarUrl:
    "https://cdn.faire.com/fastly/88e4cbee8bbfee81c2c52d9d61c91bee8d1c64412a1e444b015dae4f545b1961.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/f4f0aa8d1eff76a93e1a1e3294d9a4201798f227d2f2d542d8a5526a89542cc9.png",
  logoUrl:
    "https://cdn.faire.com/fastly/88e4cbee8bbfee81c2c52d9d61c91bee8d1c64412a1e444b015dae4f545b1961.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f4f0aa8d1eff76a93e1a1e3294d9a4201798f227d2f2d542d8a5526a89542cc9.png",
  location: "West Hollywood, CA, USA",
  minimumOrderDollars: 125,
  rating: 4.8,
  reviewCount: 20,
  isInsider: true,
  description:
    "Making art accessible. Founded in Melbourne, Australia in 2003, Third Drawer Down has collaborated with some of the most influential artists of our time, translating their works into gift and homeware collections with an uncompromising dedication to artistic integrity, functionality, and the less ordinary.\n\nThe studio has collaborated with more than 200 international artists including Louise Bourgeois, Judy Chicago, Guerrilla Girls, Alex Katz, Yayoi Kusama, Chris Ofili, Robert Rauschenberg, Cindy Sherman, Kiki Smith, David Salle, David Shrigley, and Mickalene Thomas.\n\nCurrently, women artists represent 65% of the Third Drawer Down Artist Collections, and it continues to inspire its customers to challenge gender, racial, and social barriers.\n\nLOOKING FOR YOUR OWN EXCLUSIVE PRODUCTS?\n\nEverything that comes out of Third Drawer Down Studio bears the hallmarks of creative integrity and functionality. With aims to broaden the gift market we create exclusive items, designed to cater to both your store and market.\n\n",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:59:18.553Z",
    importedBy: "entity-db-cli",
  },
};
